/** @jsxImportSource @emotion/react */

import { CSSObject } from '@emotion/react';

import { IBasePart } from '../part';
import AttributedText from '../../../components/attributedText';
import Clickable from '../../../components/clickable';
import { IAction } from '../../../hooks/useAction';
import useTheme from '../../../hooks/useTheme';

export interface IDataNavigationRowRightLabelPart extends IBasePart {
  type: 'data_navigation_row_right_label';

  topMargin: number;
  bottomMargin: number;
  leadingMargin: number;
  trailingMargin: number;
  minimumHeight: number;

  attributedText: string;
  rightAttributedText: string;

  highlightColor: string;
  imageHeight: number;
  iconName: string;
  iconUrl: string;
  iconHeight: number;
  imageName: string;
  imageUrl: string;

  action: IAction;
}

const DataNavigationRowRightLabelPart = (
  data: IDataNavigationRowRightLabelPart
) => {
  const { resolveColor } = useTheme();

  const WRAPPER_STYLE: CSSObject = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingLeft: data.leadingMargin || 20,
    paddingRight: data.trailingMargin || 20,
    paddingTop: data.topMargin || 20,
    paddingBottom: data.bottomMargin || 20,
    boxSizing: 'border-box',
    minHeight: data.minimumHeight,
    '::after': {
      content: data.iconUrl ? `''` : 'unset',
      display: 'inline-block',
      width: 28,
      height: 28,
      marginRight: 8,
      backgroundImage: `url(${data.iconUrl})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'right center',
      backgroundSize: data.iconHeight,
    },
    '&[active]': {
      backgroundColor: resolveColor(data.highlightColor),
    },
  };

  const RIGHT_LABEL_STYLE: CSSObject = {
    flex: 1,
    textAlign: 'right',
  };

  const IMAGE_STYLE: CSSObject = {
    width: 'auto',
    height: data.imageHeight,
    marginRight: 10,
    borderRadius: '50%',
  };

  return (
    <Clickable action={data.action} css={WRAPPER_STYLE}>
      {data.imageUrl && <img css={IMAGE_STYLE} src={data.imageUrl} alt='' />}
      <AttributedText text={data.attributedText} />
      <AttributedText css={RIGHT_LABEL_STYLE} text={data.rightAttributedText} />
    </Clickable>
  );
};

export default DataNavigationRowRightLabelPart;
